import { motion } from "framer-motion";
import { ArrowUpRight, RotateCcw, Share2 } from "lucide-react";
import { Logo } from "./Logo";
import { Reveal, FadeIn } from "./Reveal";
import { Marquee } from "./Marquee";
import { EmailCapture } from "./EmailCapture";

export const ResultScreen = ({ fragrance, sessionId, onRestart, onShare }) => (
  <motion.div
    data-testid="result-screen"
    initial={{ opacity: 0 }}
    animate={{ opacity: 1 }}
    transition={{ duration: 0.8 }}
    className="bg-ivory"
  >
    <div className="bg-ink text-ivory px-6 pt-12 pb-16">
      <div className="max-w-md mx-auto">
        <Logo light small />
        <p className="mt-14 font-mono text-[10px] tracking-[0.3em] uppercase text-gold">
          <Reveal delay={0.3}>Il tuo profumo oggi è</Reveal>
        </p>
        <h1
          data-testid="result-fragrance-name"
          className="mt-4 font-serif text-5xl leading-[1.05] tracking-tight"
        >
          <Reveal delay={0.45}>{fragrance.name}</Reveal>
        </h1>
        <FadeIn delay={0.8}>
          <div className="mt-8 h-px w-16 bg-gold" />
          <p className="mt-6 font-mono text-[10px] tracking-[0.25em] uppercase text-ivory/60">
            Note olfattive
          </p>
          <p data-testid="result-notes" className="mt-2 font-serif italic text-xl text-ivory">
            {fragrance.notes}
          </p>
        </FadeIn>
      </div>
    </div>

    <div className="px-6 max-w-md mx-auto">
      <FadeIn delay={0.95} className="-mt-0">
        <div className="overflow-hidden border border-gold/50">
          <img
            src={fragrance.image}
            alt={`Flacone ${fragrance.name}`}
            data-testid="result-image"
            className="w-full aspect-[4/5] object-cover"
          />
        </div>
      </FadeIn>
    </div>

    <div className="px-6 py-14 max-w-md mx-auto">
      {fragrance.resultText.map((p, i) => (
        <FadeIn key={i} delay={0.2 + i * 0.15}>
          <p className={`leading-relaxed ${i === 0 ? "font-serif text-xl text-ink" : "mt-5 text-base text-muted2"}`}>
            {p}
          </p>
        </FadeIn>
      ))}

      <FadeIn delay={0.7} className="mt-14 text-center">
        <p data-testid="ora-annusalo" className="font-serif italic text-4xl text-ink">
          Ora annusalo.
        </p>
      </FadeIn>

      <FadeIn delay={0.9} className="mt-14 space-y-3">
        <a
          href={fragrance.productUrl}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="discover-button"
          className="group flex w-full items-center justify-between border border-ink px-6 py-5 text-ink transition-colors duration-500 hover:bg-ink hover:text-ivory"
        >
          <span className="font-mono text-xs tracking-[0.3em]">SCOPRI IL PROFUMO</span>
          <ArrowUpRight className="w-4 h-4 transition-transform duration-500 group-hover:translate-x-1 group-hover:-translate-y-1" />
        </a>
        <button
          onClick={onShare}
          data-testid="share-button"
          className="group flex w-full items-center justify-between bg-olive px-6 py-5 text-ivory transition-colors duration-500 hover:bg-olive-dark"
        >
          <span className="font-mono text-xs tracking-[0.3em]">CONDIVIDI IL MIO RISULTATO</span>
          <Share2 className="w-4 h-4" />
        </button>
        <button
          onClick={onRestart}
          data-testid="restart-button"
          className="flex w-full items-center justify-center gap-2 py-5 text-muted2 transition-colors duration-300 hover:text-ink"
        >
          <RotateCcw className="w-3.5 h-3.5" />
          <span className="font-mono text-xs tracking-[0.3em]">RIFAI IL TEST</span>
        </button>
      </FadeIn>

      <EmailCapture sessionId={sessionId} />
    </div>

    <Marquee />
  </motion.div>
);
